<template>
  <div class="medication-route-codes-input">
    <el-select
      :id="inputId"
      v-model="search"
      filterable
      placeholder="Vía de administración"
      @input="handleSearchItemSelect">
      <el-option
        v-for="routeCode in routeCodes"
        :key="routeCode.code"
        :label="routeCode.display"
        :value="routeCode.code" />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'MedicationRouteCodesInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      search: this.value
    };
  },
  computed: {
    routeCodes() {
      return this.$store.getters.routeCodes;
    }
  },
  methods: {
    handleSearchItemSelect(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss">
</style>
